import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-menutop',
  templateUrl: './sessao-menutop.component.html',
  styleUrls: ['./sessao-menutop.component.scss']
})
export class SessaoMenutopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  Entrar(){
    window.open('https://app.hotelcia.com.br', '_blank');
  }

}
